<template>
  <section class="container-full-5">

    <h2 class="secondary-font gap-4 mt-2 mb-4">
      Souscription
    </h2>

    <!-- Header avec infos utilisateur -->
    <div class="s20 widget bg-gradient-dark text-white px-7 py-7 rounded-40">
      <div class="s4_mobile px-2">
        <img
          :src="profil?.photo_url || profil?.avatar_url || profil?.photo || profil?.avatar || '/public/assets/users/300w/user2.jpg'"
          width="100%"
          class="rounded-100 overflow-hidden item active"
        />
      </div>
      <div class="s16_mobile px-5 mt-5">
        <h2 class="secondary-font mb-3">
          Détail de ma souscription
        </h2>
        <h1 class="secondary-font mb-3">
          {{ profil?.prenom }} {{ profil?.nom }}
        </h1>
        <h3 class="secondary-font font-normal mb-3">
          {{ profil?.collectivite_nom || '-' }} - {{ profil?.telephone || '' }}
        </h3>
      </div>

      <div class="clear-both h-10"></div>

      <!-- 4 KPI Cards -->
      <div class="grid2">
        <div class="widget shadow-200 flex align-items-center rounded-30 px-7 py-5" style="background-color: rgba(var(--color-black-rgb), 0.8);">
          <div class="s6">
            <h1 class="secondary-font font-normal text-grey-100">Ce</h1>
            <h4 class="secondary-font font-normal text-grey-100">mois</h4>
          </div>
          <div class="s14">
            <h5 class="secondary-font font-semibold text-grey-100 mb-1">Mon Revolving</h5>
            <h1 class="secondary-font font-black text-primary-color">{{ formatAmount(monRevolving) }} F</h1>
          </div>
        </div>

        <div class="widget shadow-200 flex align-items-center rounded-30 px-7 py-5" style="background-color: rgba(var(--color-black-rgb), 0.6);">
          <div class="s6">
            <h1 class="secondary-font font-normal text-grey-100">{{ souscription?.duree_cycle_contrat_mois || 12 }}</h1>
            <h4 class="secondary-font font-normal text-grey-100">mois</h4>
          </div>
          <div class="s14">
            <h5 class="secondary-font font-semibold text-grey-100 mb-1">Revolving sur {{ souscription?.duree_cycle_contrat_mois || 12 }} mois</h5>
            <h1 class="secondary-font font-black text-primary-color">{{ formatAmount(Math.abs(souscription?.pouvoir_achat_an || 0)) }} F</h1>
          </div>
        </div>

        <div class="widget shadow-200 flex align-items-center rounded-30 px-7 py-5" style="background-color: rgba(var(--color-black-rgb), 0.6);">
          <div class="s6">
            <h1 class="secondary-font font-normal text-grey-100">{{ profil?.prelevement_pourcent || 0 }}%</h1>
          </div>
          <div class="s14">
            <h5 class="secondary-font font-semibold text-grey-100 mb-1">Prélèvement sur salaire</h5>
            <h1 class="secondary-font font-black text-primary-color">{{ formatAmount(profil?.prelevement_montant || 0) }} F</h1>
          </div>
        </div>

        <div class="widget shadow-200 flex align-items-center rounded-30 px-7 py-5" style="background-color: rgba(var(--color-black-rgb), 0.6);">
          <div class="s6">
            <h1 class="secondary-font font-normal text-grey-100">{{ quotiteDisponiblePourcent }}%</h1>
          </div>
          <div class="s14">
            <h5 class="secondary-font font-semibold text-grey-100 mb-1">Quotité encore disponible</h5>
            <h1 class="secondary-font font-black text-primary-color">{{ formatAmount(quotiteDisponibleMontant) }} F</h1>
          </div>
        </div>
      </div>

      <div class="clear-both h-30"></div>

      <!-- Détails financiers -->
      <div class="s20 px-5">
        <h5 class="s10 secondary-font mb-1">Date de souscription</h5>
        <h5 class="s10 secondary-font mb-4">{{ formatDateFrench(souscription?.date_debut) }}</h5>

        <h5 class="s10 secondary-font mb-1">Date de fin de souscription</h5>
        <h5 class="s10 secondary-font mb-4">{{ formatDateFrench(souscription?.date_fin) }}</h5>

        <hr class="hr-white s20 mb-5" />

        <h5 class="s10 secondary-font mb-1">Salaire</h5>
        <h5 class="s10 secondary-font mb-4">{{ formatAmount(profil?.salaire || 0) }} F</h5>

        <h5 class="s10 secondary-font mb-1">Prélèvement sur salaire</h5>
        <h5 class="s10 secondary-font mb-4">{{ profil?.prelevement_pourcent || 0 }}%</h5>

        <h5 class="s10 secondary-font mb-1">Utilisation totale</h5>
        <h5 class="s10 secondary-font mb-4">{{ formatAmount(profil?.prelevement_montant || 0) }} F</h5>

        <h5 class="s10 secondary-font mb-1">Salaire Net après Utilisation</h5>
        <h5 class="s10 secondary-font mb-4">{{ formatAmount((profil?.salaire || 0) - (profil?.prelevement_montant || 0)) }} F</h5>

        <hr class="hr-white s20 mb-5" />

        <h5 class="s10 secondary-font mb-1">Pouvoir d'achat</h5>
        <h5 class="s10 secondary-font mb-4">{{ formatAmount(Math.abs(souscription?.pouvoir_achat || 0)) }} F</h5>

        <h5 class="s10 secondary-font mb-1">Quotité cessible max</h5>
        <h5 class="s10 secondary-font mb-4">{{ profil?.quotite_cessible_pourcent || 0 }}% - {{ formatAmount(profil?.quotite_cessible_montant || 0) }} F</h5>

        <h5 class="s10 secondary-font mb-1">Quotité cessible encore disponible</h5>
        <h5 class="s10 secondary-font mb-4">{{ quotiteDisponiblePourcent }}% - {{ formatAmount(quotiteDisponibleMontant) }} F</h5>
      </div>
    </div>

    <div class="clear-both h-60"></div>

  </section>
</template>

<script lang="ts">
import { defineComponent, computed, onMounted } from 'vue'
import { useProfileStore } from '@/stores/profile.store'
import { useSubscriptionStore } from '@/stores/subscription.store'
import { formatAmount, formatDateFrench } from '@/utils/formatters'

export default defineComponent({
  name: 'MaSouscription',
  setup() {
    const profileStore = useProfileStore()
    const subscriptionStore = useSubscriptionStore()

    const profil = computed(() => profileStore.profil)
    const souscription = computed(() => subscriptionStore.souscription)

    const monRevolving = computed(() => {
      return Math.abs(profil.value?.revolving || 0)
    })

    const quotiteDisponiblePourcent = computed(() => {
      const max = profil.value?.quotite_cessible_pourcent || 0
      const used = profil.value?.prelevement_pourcent || 0
      return Math.max(0, max - used)
    })

    const quotiteDisponibleMontant = computed(() => {
      const max = profil.value?.quotite_cessible_montant || 0
      const used = profil.value?.prelevement_montant || 0
      return Math.max(0, max - used)
    })

    onMounted(async () => {
      await Promise.all([
        profileStore.fetchProfil(),
        subscriptionStore.fetchSouscription()
      ])
    })

    return {
      profil,
      souscription,
      monRevolving,
      quotiteDisponiblePourcent,
      quotiteDisponibleMontant,
      formatAmount,
      formatDateFrench
    }
  }
})
</script>

<style scoped>
.profile-avatar-placeholder {
  width: 100%;
  aspect-ratio: 1;
  background: rgba(255, 255, 255, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
